import md5 from 'crypto-js/md5';
const STORAGE_KEY = 'socket-device-id';

/**
 * 收集浏览器特征用于生成指纹
 */
function collectBrowserFeatures(): string[] {
  const features: string[] = [];

  // 屏幕信息
  if (typeof window !== 'undefined' && window.screen) {
    features.push(`${window.screen.width}x${window.screen.height}`);
    features.push(`depth:${window.screen.colorDepth}`);
    features.push(`pixel:${window.devicePixelRatio || 1}`);
  }

  features.push(`tz:${new Date().getTimezoneOffset()}`);

  if (typeof navigator !== 'undefined') {
    features.push(`lang:${navigator.language || 'unknown'}`);
    features.push(`platform:${navigator.platform || 'unknown'}`);
    features.push(`ua:${md5(navigator.userAgent || 'unknown')}`);
    if (navigator.hardwareConcurrency) {
      features.push(`cores:${navigator.hardwareConcurrency}`);
    }
    if ('maxTouchPoints' in navigator) {
      features.push(`touch:${navigator.maxTouchPoints}`);
    }
  }

  // 先不考虑
  // Canvas指纹
  // try {
  //   const canvas = document.createElement('canvas');
  //   const ctx = canvas.getContext('2d');
  //   if (ctx) {
  //     canvas.width = 200;
  //     canvas.height = 50;

  //     // 绘制文本
  //     ctx.textBaseline = 'alphabetic';
  //     ctx.fillStyle = '#f60';
  //     ctx.fillRect(125, 1, 62, 20);

  //     ctx.fillStyle = '#069';
  //     ctx.font = '11pt Arial';
  //     ctx.fillText('Canvas fingerprint', 2, 15);

  //     ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
  //     ctx.font = '18pt Arial';
  //     ctx.fillText('BrowserID', 4, 45);

  //     // 获取canvas数据
  //     const dataURL = canvas.toDataURL();
  //     features.push(`canvas:${simpleHash(dataURL)}`);
  //   }
  // } catch (e) {
  //   features.push('canvas:unavailable');
  // }

  // WebGL信息
  // try {
  //   const canvas = document.createElement('canvas');
  //   const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  //   if (gl && gl instanceof WebGLRenderingContext) {
  //     const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
  //     if (debugInfo) {
  //       const vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
  //       const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
  //       features.push(`gl:${simpleHash(String(vendor) + String(renderer))}`);
  //     }
  //   }
  // } catch (e) {
  //   features.push('gl:unavailable');
  // }

  return features;
}

/**
 * 生成设备指纹
 */
function generateFingerprint(): string {
  const features = collectBrowserFeatures();
  const combined = features.join('|');

  // 生成最终的指纹ID
  // const hash1 = md5(combined);
  const hash2 = md5(combined.split('').reverse().join(''));
  const timestamp = Date.now().toString(36).slice(-4);

  return `${hash2}.${timestamp}`;
}

/**
 * 获取设备ID
 */
export function getDeviceId(): string {
  // 服务端返回空值
  if (typeof window === 'undefined') {
    return '';
  }

  try {
    // 尝试从localStorage读取
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      return stored;
    }

    // 生成新的设备指纹
    const fingerprint = generateFingerprint();

    // 保存到localStorage
    try {
      sessionStorage.setItem(STORAGE_KEY, fingerprint);
    } catch {
      console.warn('Unable to save device ID to sessionStorage');
    }

    return fingerprint;
  } catch (_error) {
    // 降级方案：仅返回指纹，不存储
    console.error('Error getting device ID:', _error);
    return generateFingerprint();
  }
}

/**
 * 清除设备ID
 */
export function clearDeviceId(): void {
  if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (_e) {
      console.error('Error clearing device ID:', _e);
    }
  }
}

/**
 * 获取设备指纹详情
 */
export function getDeviceDetails() {
  if (typeof window === 'undefined') {
    return null;
  }

  const features = collectBrowserFeatures();
  const deviceId = getDeviceId();

  return {
    deviceId,
    features,
    timestamp: new Date().toISOString(),
    sessionStorage: typeof sessionStorage !== 'undefined',
  };
}
